import { useState } from "react";
import ConfirmModal from "../../../../components/Modals/ConfirmModal";
import { btn } from "../../../../components/Button/buttonStyles";

const Pill = ({ enabled }) => (
  <span
    className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded ${
      enabled ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-600"
    }`}
  >
    {enabled ? "Enabled" : "Disabled"}
  </span>
);

const Card = ({ children }) => (
  <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
    {children}
  </div>
);

const btnPrimary = btn("primary", "sm");
const btnDanger = btn("danger", "sm");
const btnWarning = btn("warning", "sm");

const ManagerView = ({
  manager,
  onEdit,
  onResendInvitation,
  onDelete,
  resendingInvitation = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleConfirmDelete = () => {
    setIsModalOpen(false);
    onDelete();
  };

  const showResend = manager.can_login && !manager.auth?.is_active;
  const fullName = `${manager.first_name || ""} ${manager.last_name || ""}`.trim();

  return (
    <div className="space-y-5">
      <section>
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
            General Info
          </h2>

          <div className="flex items-center gap-2 text-sm">
            <button onClick={onEdit} className={btnPrimary}>
              Update
            </button>
            {showResend && (
              <button
                onClick={onResendInvitation}
                disabled={resendingInvitation}
                className={btnWarning}
              >
                {resendingInvitation ? "Sending..." : "Resend Invitation"}
              </button>
            )}
            <button onClick={() => setIsModalOpen(true)} className={btnDanger}>
              Delete
            </button>
          </div>
        </div>

        <Card>
          <div className="space-y-3">
            <Field label="Full Name" value={fullName} />
            <Field
              label="Gender"
              value={manager.gender ? <span className="capitalize">{manager.gender}</span> : null}
            />
            <Field
              label="Email"
              value={
                manager.auth?.email ? (
                  <a
                    href={`mailto:${manager.auth.email}`}
                    className="text-brand-600 hover:underline"
                  >
                    {manager.auth.email}
                  </a>
                ) : null
              }
            />
            <Field label="Phone" value={manager.phone} />
            <Field label="Can Login" value={<Pill enabled={manager.can_login} />} />
          </div>
          <div className="space-y-3">
            <Field label="Role" value={manager.role?.role_details?.name} />
            <Field label="Client Pool" value={manager.client_pool?.name} />
            <Field label="Teams ID" value={manager.teams_id} />
            <Field label="Zoom ID" value={manager.zoom_id} />
            <Field label="Timezone" value={manager.timezone} />
          </div>
        </Card>
      </section>

      {isModalOpen && (
        <ConfirmModal
          title="Confirm Delete"
          message={`Are you sure you want to delete ${fullName || "this manager"}? This action cannot be undone.`}
          onCancel={() => setIsModalOpen(false)}
          onConfirm={handleConfirmDelete}
          confirmText="Delete"
        />
      )}
    </div>
  );
};

const Field = ({ label, value }) => {
  const isEmpty = value === null || value === undefined || value === "";
  return (
    <div className="flex items-start text-sm">
      <span className="w-40 shrink-0 text-xs font-medium text-gray-500 pt-px">
        {label}:
      </span>
      <span className="text-gray-900">{isEmpty ? "—" : value}</span>
    </div>
  );
};

export default ManagerView;
